<header class="cds-w-full cds-flex cds-items-center cds-justify-between cds-h-[56px]
               cds-border-b-[3px] cds-border-[#1D4ED8]">

  <div class="cds-flex cds-items-center cds-gap-2 cds-shrink-0">

    <img src="/images/logos/chubb-black.svg" alt="Chubb" class="cds-w-[140px] cds-h-auto" />

    <div class="cds-w-px cds-h-5 cds-bg-[#ddd]"></div>

    <h3 class="cds-hidden md:cds-inline-block
             cds-font-normal cds-text-[18px] md:cds-text-[20px] xl:cds-text-[22px]
             cds-ml-1">
      Existing business
    </h3>
  </div>

  <div class="cds-flex-1"></div>

  <div class="cds-flex cds-items-center cds-gap-[10px] cds-shrink-0">

    <cb-icon iconKey="utility-account-stroke" class="cds-w-5 cds-h-5 cds-text-gray-600"></cb-icon>
    <p class="cds-text-sm cds-font-medium cds-text-gray-900
             cds-border-b-[2px] cds-border-transparent
             cds-hidden sm:cds-inline-block">
      Adviser: Summit Assuranace Co. XX-XXXX
    </p>
    <p class="cds-text-sm cds-font-medium cds-text-gray-900
             cds-border-b-[2px] cds-border-transparent
             sm:cds-hidden">
      XX-XXXX
    </p>
  </div>
</header>